import { useSearchParams, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";

import { listenStory, getLanguages } from "../utils/api.js";
import { renderLocales } from "../utils/helper.js";
import Player from "../components/Player";
import Header from "../components/Header.js";
import NotFound from "./NotFound";
import Loader from "../components/Loader";

export default function StoryPlayer() {
  const [searchParams] = useSearchParams();
  const { id } = useParams();

  const [story, setStory] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const init = async () => {
    setIsLoading(true);
    try {
      // Get Locale
      const locale = searchParams.get("locale");

      // Check if storyId tourId langId inside the payload
      const [languages, story] = await Promise.all([
        getLanguages(),
        listenStory(id, locale),
      ]);

      // Apply locale
      story.locale = renderLocales([story.locale], languages);
      story.locale = story.locale[0];
      story.otherLangs = renderLocales(story.otherLangs, languages);

      setStory(story);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    init();
  }, [searchParams, id]);

  if (!isLoading) {
    if (story) {
      return (
        <>
          <ToastContainer />
          <Header story={story} />
          <div className="pt-[72px] md:pt-24 flex justify-center mb-20">
            <Player story={story} />
          </div>
        </>
      );
    } else {
      return <NotFound />;
    }
  } else {
    return <Loader />;
  }
}
